import React, { useRef, useState } from "react";
import { getFormattedNumber } from "../utils/textUtils";
import Modal from "react-bootstrap/Modal";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import { useReactToPrint } from "react-to-print";
import { deficitReport } from "../../services";

const PendingSalesOrderByCustomer = ({ resPacket, warehouse }) => {
  const [show, setShow] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [itemList, setItemList] = useState([]);
  const total = 0;
  const startDate = 0;
  const endDate = 0;
  const componentRef = useRef();

  const getPurchaseReportByItemId = (item) => {
    setSelectedItem(item);
    var request = {
      startDate: startDate,
      endDate: endDate,
      warehouseId: warehouse?.value || "",
      hsnId: "",
      itemId: item.uuid,
    };
    deficitReport(request).then((res) => {
      if (res.responsePacket) {
        setItemList(res.responsePacket);
        setShow(true);
      }
    });
  };

  const handleReactToPrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handleTaxCalculation = (row) => {
    let amt =
      parseFloat(row.itemQuantity) *
      parseFloat(row.rate) *
      ((parseFloat(row.taxRate) + 100) / 100);
    return amt;
  };

  const handlePrint = () => {};
  return resPacket.length > 0 ? (
    <>
      <div className="customTable" id="scroll">
        <table className="customTable w-100">
          <thead className="fixed-thead">
            <tr className="">
              <td>SNO.</td>
              <td className="">ORDER NO</td>
              <td className="">CUSTOMER TITLE</td>
              <td>CUSTOMER CATEGORY</td>
              <td className="">ITEM TITLE</td>
              <td>ITEM CATEGORY</td>
              <td>ITEM SUB CATEGORY</td>
              <td>ITEM QUANTITY</td>
              <td>RATE</td>
              <td>TAX RATE</td>
              <td>TOTAL AMOUNT</td>
            </tr>
          </thead>

          <tbody className="body-scroll-custom">
            {resPacket.map((row, i) => (
              <tr key={i} className="">
                <td>{i+1}</td>
                <td className="">{row.orderNo}</td>
                <td className="">{row.customerTitle}</td>
                <td className="">{row.customerCategory}</td>
                <td className="">{row.itemTitle}</td>
                <td className="">{row.itemCategory}</td>
                <td className="">{row.itemSubCategoryTitle}</td>
                <td className="">{row.itemQuantity}</td>
                {/* <td className='text-left item-title-blue cursor-pointer' onClick={() => getPurchaseReportByItemId(row)}>{row.title}</td> */}
                <td>{getFormattedNumber(row.rate)}</td>
                <td>{getFormattedNumber(row.taxRate)}</td>
                <td>{getFormattedNumber(handleTaxCalculation(row))}</td>
                {/* <td>{row.reorderPoint} {row.packUnitTitle}</td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  ) : (
    <>No Record found.</>
  );
};

export default PendingSalesOrderByCustomer;
